import { createAction } from 'redux-starter-kit';

export const search = {
  start: createAction('provider-search/search'),
  success: createAction('provider-search/search/success'),
  failure: createAction('provider-search/search/fail')
}
